import smaregi from './smaregi.config'

export { smaregi }
